import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';
import StepOrderForm from './StepOrderForm';

const QuickOrderSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      id="quick-order-form"
      sx={{
        py: { xs: 8, md: 12 },
        background: 'linear-gradient(180deg, rgba(18,18,18,0.9) 0%, rgba(26,32,48,1) 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background decoration elements */}
      <Box
        sx={{
          position: 'absolute',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(74,144,226,0.1) 0%, rgba(74,144,226,0) 70%)',
          top: '-100px',
          left: '-100px',
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(92,107,192,0.1) 0%, rgba(92,107,192,0) 70%)',
          bottom: '-200px',
          right: '-200px',
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h2"
            component="h2"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: { xs: '2.5rem', md: '3rem' },
              background: 'linear-gradient(45deg, #4A90E2 30%, #5C6BC0 90%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb: 2,
            }}
          >
            {t('home.quickOrder.title')}
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{
              maxWidth: 700,
              mx: 'auto',
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            {t('home.quickOrder.subtitle')}
          </Typography>
        </Box>
        
        <StepOrderForm />
      </Container>
    </Box>
  );
};

export default QuickOrderSection; 